import { MediaFormats, probeForFallback } from '../Common/MediaFormats'
import * as api from './app.api'
import { ApplicationPage, CustomTenantTheme, fetchLandingPage } from './app.api'
import { LOCAL_STORAGE_LAST_USED_THEME_CONFIG } from './app.constants'
import { AppThunk } from './app.reducer'
import { LoginAction } from './LegacyLogin/login-action-types'

interface SetLoadingAction { type: 'APP_LOADING', loading: boolean }
export const setLoading = (loading = true): SetLoadingAction => ({
  type: 'APP_LOADING',
  loading,
})

interface SetReadyAction { type: 'APP_READY', ready: boolean }
export const setReady = (ready = true): SetReadyAction => ({
  type: 'APP_READY',
  ready,
})

interface SetInitialRouteAction { type: 'APP_INITIAL_ROUTE', initialRoute: string | null }
export const setInitialRoute = (initialRoute = null): SetInitialRouteAction => ({
  type: 'APP_INITIAL_ROUTE',
  initialRoute,
})

interface SetRouteReadyAction { type: 'APP_ROUTE_READY', routeReady: boolean }
export const setRouteReady = (routeReady = true): SetRouteReadyAction => {
  return {
    type: 'APP_ROUTE_READY',
    routeReady,
  }
}

interface GetPrerequisitesSuccessAction { type: 'GET_PREREQUISITES_SUCCESS', prerequisites: api.Prerequisites }
export const getPrerequisitesSuccess = (prerequisites: api.Prerequisites): GetPrerequisitesSuccessAction => ({
  type: 'GET_PREREQUISITES_SUCCESS',
  prerequisites,
})

interface GetPrerequisitesFailureAction { type: 'GET_PREREQUISITES_FAILURE', error: $TSFIXME }
export const getPrerequisitesFailure = (error: $TSFIXME): GetPrerequisitesFailureAction => ({
  type: 'GET_PREREQUISITES_FAILURE',
  error,
})

type MediaFormatsData = $TSFIXME
interface SetMediaFormatsAction { type: 'SET_MEDIA_FORMATS', data: MediaFormatsData }
export const setMediaFormatsAction = (data: MediaFormats): SetMediaFormatsAction => ({
  type: 'SET_MEDIA_FORMATS',
  data,
})

export const getPrerequisites = (): AppThunk => {
  return async dispatch => {
    try {
      const prerequisites = await api.getPrerequisites()
      dispatch(getPrerequisitesSuccess(prerequisites))
    } catch (e) {
      dispatch(getPrerequisitesFailure(e))
    }
  }
}

interface GetDxStatusSuccessAction { type: 'GET_DX_STATUS_SUCCESS', status: api.DxAccounts }
export const getDxStatusSuccess = (status: api.DxAccounts): GetDxStatusSuccessAction => ({
  type: 'GET_DX_STATUS_SUCCESS',
  status,
})

interface GetDxStatusFailureAction { type: 'GET_DX_STATUS_FAILURE', error: $TSFIXME }
export const getDxStatusFailure = (error: $TSFIXME): GetDxStatusFailureAction => ({
  type: 'GET_DX_STATUS_FAILURE',
  error,
})

interface GetDxUserAccessSuccessAction { type: 'GET_DX_USER_ACCESS_SUCCESS', status: boolean }
export const getdxUserAccessSuccess = (status: boolean): GetDxUserAccessSuccessAction => ({
  type: 'GET_DX_USER_ACCESS_SUCCESS',
  status,
})

interface GetDxUserAccessFailureAction { type: 'GET_DX_USER_ACCESS_FAILURE', error: $TSFIXME }
export const getdxUserAccessFailure = (error: $TSFIXME): GetDxUserAccessFailureAction => ({
  type: 'GET_DX_USER_ACCESS_FAILURE',
  error,
})

export const getDxStatus = (): AppThunk => {
  return async dispatch => {
    try {
      const status = await api.getDxStatus()
      dispatch(getDxStatusSuccess(status))
    } catch (e) {
      dispatch(getDxStatusFailure(e))
    }
  }
}

interface GetFRDxStatusSuccessAction { type: 'GET_FR_DX_STATUS_SUCCESS', status: api.DxAccounts }
export const getFRDxStatusSuccess = (status: api.DxAccounts): GetFRDxStatusSuccessAction => ({
  type: 'GET_FR_DX_STATUS_SUCCESS',
  status,
})

interface GetFRDxStatusFailureAction { type: 'GET_FR_DX_STATUS_FAILURE', error: $TSFIXME }
export const getFRDxStatusFailure = (error: $TSFIXME): GetFRDxStatusFailureAction => ({
  type: 'GET_FR_DX_STATUS_FAILURE',
  error,
})

export const getFRDxStatus = (dxStatusConfig: $TSFIXME): AppThunk => {
  return async dispatch => {
    try {
      const status = await api.getFRDxStatus(dxStatusConfig)
      dispatch(getFRDxStatusSuccess(status))
    } catch (e) {
      dispatch(getFRDxStatusFailure(e))
    }
  }
}

export const getDxUserAccess = (): AppThunk => {
  return async dispatch => {
    try {
      const status = await api.getDxUserAccess()
      // if ANY role is true then user defaults to a DX Dashboard
      const isDx = status.some(role => {
        return role.isDx === true
      })
      dispatch(getdxUserAccessSuccess(isDx))
    } catch (e) {
      dispatch(getdxUserAccessFailure(e))
    }
  }
}

interface GetLaunchDarklyConfigSuccessAction { type: 'GET_LAUNCHDARKLY_CONFIG_SUCCESS', launchDarklyConfig: api.FeatureFlagConfig }
export const getLaunchDarklyConfigSuccess = (launchDarklyConfig: api.FeatureFlagConfig): GetLaunchDarklyConfigSuccessAction => ({
  type: 'GET_LAUNCHDARKLY_CONFIG_SUCCESS',
  launchDarklyConfig,
})

interface GetLaunchDarklyConfigFailureAction { type: 'GET_LAUNCHDARKLY_CONFIG_FAILURE', error: $TSFIXME }
export const getLaunchDarklyConfigFailure = (error: $TSFIXME): GetLaunchDarklyConfigFailureAction => ({
  type: 'GET_LAUNCHDARKLY_CONFIG_FAILURE',
  error,
})

export const getLaunchDarklyConfig = (): AppThunk => {
  return async dispatch => {
    try {
      const ldConfig = await api.getLaunchDarklyConfig()
      dispatch(getLaunchDarklyConfigSuccess(ldConfig))
    } catch (e) {
      dispatch(getLaunchDarklyConfigFailure(e))
    }
  }
}

type AppProperties = $TSFIXME
interface GetAppPropertiesSuccessAction { type: 'GET_APP_PROPERTIES_SUCCESS', appProperties: AppProperties }
export const getAppPropertiesSuccess = (appProperties: AppProperties): GetAppPropertiesSuccessAction => ({
  type: 'GET_APP_PROPERTIES_SUCCESS',
  appProperties,
})

interface GetAppPropertiesFailureAction { type: 'GET_APP_PROPERTIES_FAILURE', error: $TSFIXME }
export const getAppPropertiesFailure = (error: $TSFIXME): GetAppPropertiesFailureAction => ({
  type: 'GET_APP_PROPERTIES_FAILURE',
  error,
})

export const getAppProperties = (): AppThunk => {
  return async dispatch => {
    try {
      const appProperties = await api.getAppProperties()
      dispatch(getAppPropertiesSuccess(appProperties))
    } catch (e) {
      dispatch(getAppPropertiesFailure(e))
    }
  }
}

interface GetUserLicenseSuccessAction { type: 'GET_USER_LICENSE_SUCCESS', userLicenses: api.UserLicenses }
export const getUserLicensesSuccess = (userLicenses: api.UserLicenses): GetUserLicenseSuccessAction => ({
  type: 'GET_USER_LICENSE_SUCCESS',
  userLicenses,
})

interface GetUserLicenseFailureAction { type: 'GET_USER_LICENSE_FAILURE', error: $TSFIXME }
export const getUserLicensesFailure = (error: $TSFIXME): GetUserLicenseFailureAction => ({
  type: 'GET_USER_LICENSE_FAILURE',
  error,
})

export const getUserLicenses = (userId: number): AppThunk => {
  return async dispatch => {
    try {
      const userLicenses = await api.getUserLicenses(userId)
      dispatch(getUserLicensesSuccess(userLicenses))
    } catch (e) {
      dispatch(getUserLicensesFailure(e))
    }
  }
}

type TeleoptiConfig = Record<string, string>
interface GetTeleoptiConfigSuccessAction { type: 'GET_TELEOPTI_CONFIG_SUCCESS', teleoptiConfig: TeleoptiConfig }
export const getTeleoptiConfigSuccess = (teleoptiConfig: Record<string, string>): GetTeleoptiConfigSuccessAction => ({
  type: 'GET_TELEOPTI_CONFIG_SUCCESS',
  teleoptiConfig,
})

interface GetTeleoptiConfigFailureAction { type: 'GET_TELEOPTI_CONFIG_FAILURE', error: $TSFIXME }
export const getTeleoptiConfigFailure = (error: $TSFIXME): GetTeleoptiConfigFailureAction => ({
  type: 'GET_TELEOPTI_CONFIG_FAILURE',
  error,
})

export const getTeleoptiConfig = (tenantId: number): AppThunk => {
  return async dispatch => {
    try {
      const teleopti = await api.getTeleoptiConfig(tenantId)
      const teleoptiConfig = teleopti.reduce<TeleoptiConfig>((map, obj) => {
        map[obj.name] = obj.value
        return map
      }, {})
      dispatch(getTeleoptiConfigSuccess(teleoptiConfig))
    } catch (e) {
      dispatch(getTeleoptiConfigFailure(e))
    }
  }
}

interface GetThemeRequestAction { type: 'GET_THEME_REQUEST' }
interface GetThemeSuccessAction { type: 'GET_THEME_SUCCESS', theme: CustomTenantTheme }
interface GetThemeFailureAction { type: 'GET_THEME_FAILURE', error: $TSFIXME }
const getThemeRequest = (): GetThemeRequestAction => ({ type: 'GET_THEME_REQUEST' })
const getThemeSuccess = (theme: CustomTenantTheme): GetThemeSuccessAction => ({ type: 'GET_THEME_SUCCESS', theme })
const getThemeFailure = (error: $TSFIXME): GetThemeFailureAction => ({ type: 'GET_THEME_FAILURE', error })
export const getTheme = (): AppThunk => async dispatch => {
  dispatch(getThemeRequest())
  try {
    const theme = await api.getTheme()
    localStorage.setItem(LOCAL_STORAGE_LAST_USED_THEME_CONFIG, JSON.stringify(theme.data))
    dispatch(getThemeSuccess(theme.data))
  } catch (error) {
    dispatch(getThemeFailure(error))
  }
}

export const setMediaFormats = (): AppThunk => {
  return dispatch => {
    const temp = probeForFallback()
    temp.then(resp => {
      dispatch(setMediaFormatsAction({ audio: resp.audio, video: resp.video }))
    })
  }
}

interface SetFedRAMPComplianceAction { type: 'SET_FEDRAMP_COMPLIANCE', fedRAMPCompliance: boolean }
export const setFedRAMPCompliance = (fedRAMPCompliance = false): SetFedRAMPComplianceAction => ({
  type: 'SET_FEDRAMP_COMPLIANCE',
  fedRAMPCompliance,
})

export const SET_LANDING_PAGE = 'SET_LANDING_PAGE'
interface SetLandingPageAction { type: 'SET_LANDING_PAGE', landingPage: ApplicationPage | null }
export const setLandingPage = (landingPage: ApplicationPage | null) => ({
  type: SET_LANDING_PAGE,
  landingPage,
})

export const getLandingPage = (serviceEndpoint: string, timeout = 1000): AppThunk => async dispatch => {
  dispatch(setRouteReady(false))
  try {
    const landingPageResponse = await fetchLandingPage(serviceEndpoint, timeout)
    dispatch(setLandingPage(landingPageResponse))
  } catch {
    dispatch(setLandingPage(null))
  } finally {
    dispatch(setRouteReady(true))
  }
}

export type AppAction =
  | GetDxStatusFailureAction
  | GetDxStatusSuccessAction
  | GetDxUserAccessFailureAction
  | GetDxUserAccessSuccessAction
  | GetLaunchDarklyConfigFailureAction
  | GetLaunchDarklyConfigSuccessAction
  | GetAppPropertiesFailureAction
  | GetAppPropertiesSuccessAction
  | GetUserLicenseSuccessAction
  | GetUserLicenseFailureAction
  | GetPrerequisitesFailureAction
  | GetPrerequisitesSuccessAction
  | GetTeleoptiConfigFailureAction
  | GetTeleoptiConfigSuccessAction
  | GetThemeFailureAction
  | GetThemeRequestAction
  | GetThemeSuccessAction
  | LoginAction
  | SetFedRAMPComplianceAction
  | SetLoadingAction
  | SetMediaFormatsAction
  | SetReadyAction
  | SetLandingPageAction
  | SetRouteReadyAction
  | SetInitialRouteAction
